module.exports = __webpack_public_path__ + "static/image2-48410e6bc2f15b43fa9a19455fd04ee0.jpeg";